import React from 'react';

import { PipelineStepStatusIconButton } from '@/console/features/pipelines/components/pipeline-step-status-chip/pipeline-step-status-chip.styled';
import { TPipelineStepStatusChipProps } from '@/console/features/pipelines/components/pipeline-step-status-chip/pipeline-step-status-chip.types';
import { usePipelineStepType } from '@/console/features/pipelines/hooks/use-pipeline-step-type/use-pipeline-step-type';
import { useJobStatus } from '@/shared/features/jobs/hooks/use-job-status/use-job-status';

export const PipelineStepStatusChip: React.FC<TPipelineStepStatusChipProps> = ({
  step,
  ...rest
}) => {
  const { getStatusColor, getStatusIcon, getStatusLabel } = useJobStatus();
  const { getStepTypeIcon, getStepTypeLabel } = usePipelineStepType();

  const getStatus = () => {
    if (step.__typename === 'PipelineExecutionStepResponseType') {
      return getStatusColor(step.status);
    }
    return 'grey';
  };

  const getTooltip = () => {
    const stepTitle = step.name ?? getStepTypeLabel(step.type);
    if (step.__typename === 'PipelineExecutionStepResponseType') {
      return `${stepTitle}: ${getStatusLabel(step.status)}`;
    }
    return stepTitle;
  };

  const renderIcon = () => {
    if (step.__typename === 'PipelineExecutionStepResponseType') {
      return getStatusIcon(step.status);
    }
    return getStepTypeIcon(step.type);
  };

  return (
    <PipelineStepStatusIconButton
      {...rest}
      $status={getStatus()}
      tooltip={getTooltip()}
      tooltipProps={{ placement: 'top' }}
    >
      {renderIcon()}
    </PipelineStepStatusIconButton>
  );
};
